import ServerApi from './$server.api'

export default {
    getMerchandises,
    createMerchandise,
    updateMerchandise,
    deleteMerchandise
}

async function getMerchandises() {
    return await ServerApi.request('get', '/merchandises')
}

async function createMerchandise(data) {
    return await ServerApi.request('post', '/merchandises', {data})
}

async function updateMerchandise(merchandiseId, data) {
    return await ServerApi.request('put', `/merchandises/${merchandiseId}`, {data})
}

async function deleteMerchandise(merchandiseId) {
    return await ServerApi.request('delete', `/merchandises/${merchandiseId}`)
}